import React, { useContext } from "react";

import {
    Modal,
    Box,
    Typography,
    IconButton,

} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EmptyView from "../../../../Component/EmptyView/EmptyView";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../../../../Component/Spinner/Spinner";
import { MONITORING_LLM_LABELS } from "../../../../utils/constant";
import { DiscoveryContext } from "../../../BrandAudit/discovery-context";
import { dynamicReplace } from "./ActionModal";

export const CommonInfoCard = ({ data, useCardWrapper = true }) => {
    const { brand, persona, llm, geography, category, market, isProduct } =
        data || {};
    const case1 = [
        brand,
        category,
        MONITORING_LLM_LABELS?.[llm] || llm,
        persona,
        market,
        geography,
    ]
        .filter(Boolean)
        .join(" | ");
    return (
        <p
            style={{
                fontSize: !useCardWrapper ? "15px" : "20px",
                fontWeight: "bold",
            }}
        >
            {case1}
        </p>
    );
};



const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    maxHeight: "90vh",
    overflowY: "auto",
    borderRadius: "8px",
};

const NonActionModal = ({ open, handleClose, data, isDataLoading, nonActionsData }) => {

    const discoveryCtx = useContext(DiscoveryContext);
    const isPropensity = discoveryCtx?.isPropensityToBuy?.() ?? (discoveryCtx?.brand_scores?.rbiType === "propensityToBuy");
    const mapTitle = (t) => discoveryCtx?.mapMetricTitle?.(t) ?? t;

    const maybeMap = (s) => {
        if (!s || typeof s !== "string") return s;
        return isPropensity ? mapTitle(s) : s;
    };

    return (
        <>
            <Modal
                open={open}
                onClose={() => {
                    handleClose();
                }}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box sx={style}>
                    <IconButton
                        id="close_id"
                        onClick={() => {

                            handleClose();
                        }}
                        sx={{ position: "absolute", top: 8, right: 8, color: "gray" }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <CommonInfoCard data={data} />
                    <Typography variant="h6" component="div">
                        Action Data Summary
                    </Typography>
                    <hr />

                    {isDataLoading ? (
                        <Spinner />
                    ) : !nonActionsData || nonActionsData.length === 0 ? <EmptyView message="Nothing here" /> : null}

                    {!isDataLoading && nonActionsData && nonActionsData.length > 0 && <ul style={{ listStyleType: "square", paddingLeft: "20px" }}>
                        {nonActionsData?.map((item, index) => (
                            <React.Fragment key={index}>
                                <li style={{}}>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            width: "100%",
                                        }}
                                    >
                                        <Typography variant="body1" component="span">
                                            {maybeMap(dynamicReplace(item))}
                                        </Typography>

                                    </div>
                                </li>
                                <hr />
                            </React.Fragment>
                        ))}
                    </ul>}
                </Box>
            </Modal>
            <ToastContainer />
        </>
    );
};

export default NonActionModal;
